var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-tile",
    { key: _vm.plot.Id },
    [
      _c(
        "v-list-tile-content",
        [
          _c("v-list-tile-title", [
            _vm._v(_vm._s(_vm.plot.PlotName || _vm.plot.Id)),
          ]),
          _vm._v(" "),
          _c(
            "v-list-tile-sub-title",
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "plot-label-row",
                              attrs: { xs12: "" },
                            },
                            [
                              _c("span", { staticClass: "text--primary" }, [
                                _vm._v("Plot Type: "),
                              ]),
                              _vm._v(
                                _vm._s(_vm.plot.PlotType) + "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "plot-label-row",
                              attrs: { xs12: "" },
                            },
                            [
                              _c("span", { staticClass: "text--primary" }, [
                                _vm._v("Community Type: "),
                              ]),
                              _vm._v(
                                _vm._s(_vm.plot.CommunityType) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm2: "", "offset-sm2": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "text--primary" }, [
                              _vm._v(_vm._s(_vm.plot.ChildrenPlots.length)),
                            ]),
                            _vm._v(" Subplots"),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "text--primary" }, [
                              _vm._v(_vm._s(_vm.plot.Specimena.length)),
                            ]),
                            _vm._v(" Specimena"),
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("span", { staticClass: "text--primary" }, [
                              _vm._v(_vm._s(_vm.plot.Surveys.length)),
                            ]),
                            _vm._v(" Surveys"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm1: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", round: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push(
                                `/vegetativemonitoring/plot/${_vm.plot.Id}`
                              )
                            },
                          },
                        },
                        [_vm._v("View")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.pad
        ? _c("v-list-tile-action", [_c("div", { staticClass: "dropdown-pad" })])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }